<template>
  <div class="modal is-active db-settings--confirm-dialog">
    <div class="modal-background" @click="cancel"></div>
    <div class="modal-content">
      <div class="box">
        <h4 class="title">{{ $t("Sync setup") }}</h4>
        <p>
          {{
            $t(
              "You are now setting up data synchronisation with the selected account."
            )
          }}
        </p>
        <div class="field">
          <label>
            <input
              type="checkbox"
              class="db-settings--confirm-dialog--keep-checkbox"
              v-model="keepLocalData"
            />
            {{ $t("Keep my existing local data and sync it.") }}
          </label>
        </div>
        <div class="field is-grouped">
          <div class="control">
            <button
              @click="confirm"
              class="button is-primary db-settings--confirm-dialog--confirm-button"
            >
              {{ $t("OK, start syncing") }}
            </button>
          </div>
          <div class="control">
            <button
              @click="cancel"
              class="button db-settings--confirm-dialog--cancel-button"
            >
              {{ $t("Cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default Vue.extend({
  name: "DbSettingsConfirm",
  props: {
    initKeepLocalData: Boolean,
  },
  data() {
    return { keepLocalData: this.initKeepLocalData };
  },
  methods: {
    confirm() {
      this.$emit("userConfirmed", { keepLocalData: this.keepLocalData });
    },
    cancel() {
      this.$emit("userCancelled");
    },
  },
});
</script>
<i18n>
{
  "en": {},
  "de": {
    "Sync setup": "Synchronisation einrichten",
    "You are now setting up data synchronisation with the selected account.": "Du aktivierst jetzt die Synchronisation mit dem gewählten Account.",
    "Keep my existing local data and sync it.": "Bestehende Daten behalten und dorthin synchronisieren.",
    "OK, start syncing": "OK, Synchronisation starten",
    "Cancel": "Abbrechen"
  }
}
</i18n>
